import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Menu } from "antd";
import {
  FundProjectionScreenOutlined,
  ControlOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

const NavMenu = () => {
  const location = useLocation();

  const MenuList = [
    {
      label: <NavLink to={`/system_manage`}>banner管理</NavLink>,
      key: "banners",
      icon: <FundProjectionScreenOutlined />,
    },
    {
      label: <NavLink to={`/system_manage/category`}>菜单管理</NavLink>,
      key: "category",
      icon: <ControlOutlined />,
      selected: location.pathname.startsWith("/system_manage/category"),
    },
    {
      label: <NavLink to={`/system_manage/article`}>内容管理</NavLink>,
      key: "article",
      icon: <FileTextOutlined />,
      selected: location.pathname.startsWith("/system_manage/article"),
    },
    {
      label: <NavLink to={`/system_manage/article_about`}>关于我们</NavLink>,
      key: "article_about",
      icon: <FileTextOutlined />,
      selected: location.pathname.startsWith("/system_manage/article_about"),
    },
    {
      label: <NavLink to={`/system_manage/article_contact`}>联系我们</NavLink>,
      key: "article_contact",
      icon: <FileTextOutlined />,
      selected: location.pathname.startsWith("/system_manage/article_contact"),
    },
  ];

  const [defaultActiveKey, defaultOpenKeys] = MenuList.reduce(
    (ret: any, item: any) => {
      let active: any = item;
      if (!!item.children) {
        active = item.children.find(
          (subitem: any) => !!subitem.selected && subitem.label
        );
      }
      if (!!active && !!active.selected) {
        ret = [active.key, item.children ? [item.key] : []];
      }
      return ret;
    },
    ["banners", []]
  );

  return (
    <Menu
      theme="light"
      mode="inline"
      className="system-sidebar-menu"
      items={MenuList}
      defaultOpenKeys={defaultOpenKeys}
      defaultSelectedKeys={defaultActiveKey}
    ></Menu>
  );
};

export default NavMenu;